var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":(_vm.routePath || _vm.$route.path) + '/' + _vm.id + '?origin=' + _vm.origin,"target":_vm.target}},[(_vm.$slots.content)?_vm._t("content"):_c('span',[_vm._v(_vm._s(_vm.number))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }